import { render, staticRenderFns } from "./AddRegionModal.vue?vue&type=template&id=110dae7b&scoped=true&"
import script from "./AddRegionModal.vue?vue&type=script&lang=ts&"
export * from "./AddRegionModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddRegionModal.vue?vue&type=style&index=0&id=110dae7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110dae7b",
  null
  
)

export default component.exports